(() => {
  if (customElements.get('sf-product-rail')) return;
  customElements.define(
    'sf-product-rail',
    class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const opts = { signal: this.controller.signal };
        this.track = this.querySelector('[data-product-rail]');
        if (!this.track) return;
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const prev = this.querySelector('[data-rail-prev]');
          const next = this.querySelector('[data-rail-next]');
          if (prev) prev.disabled = this.track.scrollLeft <= 2;
          if (next) next.disabled = this.track.scrollLeft >= max - 2;
          const fill = this.querySelector('[data-rail-fill]');
          if (fill) {
            const visible = this.track.clientWidth / Math.max(this.track.scrollWidth, 1);
            const fraction = max > 0 ? Math.max(0, Math.min(1, this.track.scrollLeft / max)) : 1;
            fill.style.setProperty('--rail-progress', visible + fraction * (1 - visible));
          }
        };
        this.addEventListener(
          'click',
          (event) => {
            const button = event.target.closest('[data-rail-prev],[data-rail-next]');
            if (!button || button.disabled) return;
            const direction = button.hasAttribute('data-rail-prev') ? -1 : 1;
            const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
            const width = this.track.firstElementChild?.getBoundingClientRect().width || this.track.clientWidth;
            this.track.scrollBy({
              left: direction * (width + gap),
              behavior:
                event.detail === 0 || matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth',
            });
          },
          opts,
        );
        this.track.addEventListener(
          'focusin',
          (event) => {
            const card = event.target.closest('article, .sf-rail-view-all');
            if (card && this.track.scrollWidth > this.track.clientWidth) {
              card.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'instant' });
            }
          },
          opts,
        );
        this.track.addEventListener('scroll', this.update, { ...opts, passive: true });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    },
  );
})();
